export default __webpack_public_path__ + "static/media/photo_5282747746622312923_y.768a36bc.jpg";